import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "2bed5355-af5f-4958-9ec1-8fde98fed35b", content: "Boredom effects", options: {} },
  { id: "df5d9995-2512-4e1f-acf6-cb098290db99", content: "Latin square balancing", options: {} },
  { id: "787ddd41-025f-4239-b034-2f0b12c48e08", content: "Practice effects", options: {} },
  { id: "b2fc1802-4d7b-4396-b59a-45a8d073c764", content: "Boxplot", options: {} },
  { id: "b411228d-2345-442c-b64d-a449730fad43", content: "Variance analysis", options: {} },
  { id: "9b0d52f4-3f6b-4943-8294-219c15b73545", content: "Descriptive statistics", options: {} },
  { id: "e229c604-ec8e-47e9-b67d-7aa0e7770877", content: "Between-subject", options: {} },
  { id: "e91817bb-78fe-46da-8365-72ff62674853", content: "Within-subject", options: {} },
  { id: "c79f4564-3e76-4aaf-8ef8-2eaa9040f123", content: "Condition", options: {} },
  { id: "a7bf09fc-5ef6-47d0-a5f3-06ff2f789c70", content: "Dependent variable", options: {} },
  { id: "0d02750f-cc3a-41a4-a281-07eac9269b79", content: "Independent variables", options: {} },
];

const groups = [
  { id: "cdc83598-4df9-4f6a-9ef4-d8ba2ec0dfbf", content: "repeated measures design", options: {} },
  { id: "51fae346-4e9f-43a0-87d6-c2ec36f68df5", content: "evaluation", options: {} },
  { id: "881966d9-eb9b-4165-ab7b-034b83424ab5", content: "design types", options: {} },
  { id: "17a5673a-c899-43f6-b0f8-386959057277", content: "experimental variables", options: {} },
];

export const task: Task = {
  id: "fb414dcb-6ef2-40aa-b3f3-2933d9982d43",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "cdc83598-4df9-4f6a-9ef4-d8ba2ec0dfbf",
      itemsId: [
        "2bed5355-af5f-4958-9ec1-8fde98fed35b",
        "df5d9995-2512-4e1f-acf6-cb098290db99",
        "787ddd41-025f-4239-b034-2f0b12c48e08",
      ],
    },
    {
      groupId: "51fae346-4e9f-43a0-87d6-c2ec36f68df5",
      itemsId: [
        "b2fc1802-4d7b-4396-b59a-45a8d073c764",
        "b411228d-2345-442c-b64d-a449730fad43",
        "9b0d52f4-3f6b-4943-8294-219c15b73545",
      ],
    },
    {
      groupId: "881966d9-eb9b-4165-ab7b-034b83424ab5",
      itemsId: ["e229c604-ec8e-47e9-b67d-7aa0e7770877", "e91817bb-78fe-46da-8365-72ff62674853"],
    },
    {
      groupId: "17a5673a-c899-43f6-b0f8-386959057277",
      itemsId: [
        "c79f4564-3e76-4aaf-8ef8-2eaa9040f123",
        "a7bf09fc-5ef6-47d0-a5f3-06ff2f789c70",
        "0d02750f-cc3a-41a4-a281-07eac9269b79",
      ],
    },
  ],
};
